import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { SeedReturnItemsFilter } from '../../../models/SeedReturn/SeedReturnItemsFilter';
import { ToastrService } from 'ngx-toastr';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { CommonService } from './../../../services/common/common.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { MasterConstants } from './../../../common/constants/master-constants';
import { Subscription } from 'rxjs';
import { SeedReturnService } from './../../../services/seed/seed-return.service';

@Component({
  selector: 'app-seedreturnfilter',
  templateUrl: './seed-return-filter.component.html',
  styleUrls: ['./seed-return-filter.component.scss']
})

export class SeedReturnFilterComponent implements OnDestroy {
  private subscription = new Array<Subscription>();
  selectedFilter: string;
  filterValueList: any[] = [];
  filterList: any[];
  headerYear: string;
  headerCompany: string;
  searchButtonClick = false;
  filter: SeedReturnItemsFilter = new SeedReturnItemsFilter();
  productFilters: any;
  searchValue = '';
  invoicedProductList: any = [];
  lotNumberList: any = [];
  invoiceNumberList: any = [];
  disableFilterBtn = true;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  isPaste = false;
  public partialSearchValue = '';

  @Input()
  set filters(val: any[]) {
    this.filterList = val;
    if (val[0]) { this.selectedFilter = val[0].column; }
  }
  get filters(): any[] {
    return this.filterList;
  }

  @Output()
  SearchFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  ClearFilter: EventEmitter<any> = new EventEmitter<any>();

  constructor(public commonService: CommonService,
    public toastrService: ToastrService,
    private seedReturnService: SeedReturnService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private localStorageService: LocalStorageService,
  ) {
    this.resetFilterInputValue();

    // get lot list based on selected account
    this.subscription.push(this.seedReturnService.getLotMasterList(this.seedReturnService.getSelectedAccountNo()).subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.lotNumberList = result.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
      }
    }));

    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    if (this.filters && this.filters.length > 0 && this.filters.find(x => x.column == 'invoiceNumber')) {
      // Invoice Number list
      this.subscription.push(this.seedReturnService.getInvoiceNumberList(this.seedReturnService.getSelectedAccountNo()).subscribe((result: any[]) => {
        this.invoiceNumberList = result;
      }));
    }

    // Treatment master list
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    this.subscription.push(this.seedReturnService.SelectedProductLineId.subscribe(s => {
      if (s == '4J1') {
        // Marketing brand master data
        if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
          this.marketingBrandMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
          if (this.seedReturnService.returnPeriodSecurityList == undefined) {
            this.subscription.push(this.seedReturnService.getReturnPeriodSecurity().subscribe((result: any[]) => {
              this.seedReturnService.setReturnPeriodSecurityList(result);
              this.marketingBrandMasterList = this.marketingBrandMasterList.filter(x => this.seedReturnService.returnPeriodSecurityList.some(y => y.marketingBrandID == x.id));
            }));
          }
          else {
            // Marketing brand master data
            this.marketingBrandMasterList = this.marketingBrandMasterList.filter(x => this.seedReturnService.returnPeriodSecurityList.some(y => y.marketingBrandID == x.id));
          }
        }
      }
      else {
        // Marketing brand master data
        if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
          this.marketingBrandMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
        }
      }
    }));

    this.searchButtonClick = false;
  }
  public selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productName = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.productName);
      this.retainFilter(this.productFilters.productName, 'ProductName');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }
  public selectTechnology($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.technology = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.technology = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.technology = this.partialSearchValue;
        }
      }
      this.validateProductSearch(this.productFilters.technology);
      this.retainFilter(this.productFilters.technology, 'Technology');
      this.onFilter();
    }
    else {
      this.resetFilterInputValue();
    }
  }
  onPaste(event: ClipboardEvent) {
    if (event) {
      const clipboardData = event.clipboardData;
      const selectedValue = clipboardData.getData('text');
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        this.disableFilterBtn = false;
        this.isPaste = true;
      }
    }
    else {
      this.resetFilterInputValue();
    }
  }

  validateProductSearch(toValidateInput: any) {
    // To Validate Brand
    if ((toValidateInput !== null && toValidateInput !== '' && toValidateInput.toString().trim().length >= 2)
      || this.productFilters.itemNo !== null && this.productFilters.itemNo !== '' && this.productFilters.itemNo.toString().trim().length >= 2
      || this.productFilters.lotNumber !== null && this.productFilters.lotNumber !== '' && this.productFilters.lotNumber.toString().trim().length >= 2
      || this.productFilters.invoiceNumber !== null && this.productFilters.invoiceNumber !== '' && this.productFilters.invoiceNumber.toString().trim().length >= 2
      || this.productFilters.productName !== null && this.productFilters.productName !== '' && this.productFilters.productName.toString().trim().length >= 2
      || this.productFilters.packageSize !== null && this.productFilters.packageSize !== '' && this.productFilters.packageSize.toString().trim().length >= 2
      || this.productFilters.seedSize !== null && this.productFilters.seedSize !== '' && this.productFilters.seedSize.toString().trim().length >= 2
      || this.productFilters.treatment !== null && this.productFilters.treatment !== '' && this.productFilters.treatment.toString().trim().length >= 2
      || this.productFilters.technology !== null && this.productFilters.technology !== '' && this.productFilters.technology.toString().trim().length >= 2
      || this.productFilters.marketingBrand !== null && this.productFilters.marketingBrand !== '' && this.productFilters.marketingBrand.toString().trim().length >= 2
    ) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = this.isPaste ? false : true;
      this.isPaste = false;
    }
  }
  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    if (this.filterValueList) {
      const selectedIds = '';

      switch (type) {
        case 'LotNo':
          this.filter.lotNumber = selectedIds;
          break;
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'InvoiceNo':
          this.filter.invoiceNumber = selectedIds;
          break;
        case 'MarketingBrand':
          this.filter.marketingBrand = selectedIds;
          break;
        case 'ProductName':
          this.filter.productName = selectedIds;
          break;
        case 'Treatment':
          this.filter.treatment = selectedIds;
          break;
        case 'Technology':
          this.filter.technology = selectedIds;
          break;
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
        case 'SeedSize':
          this.filter.seedSize = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        // Set Item No
        if (this.productFilters.itemNo && this.productFilters.itemNo.length > 0) {
          var strINO = '';
          this.productFilters.itemNo.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strINO.substr(0, strINO.length - 2));
          this.filter.itemNo = strINO.substr(0, strINO.length - 2);
        }

        // Set invoice No
        if (this.productFilters.invoiceNumber && this.productFilters.invoiceNumber.length > 0) {
          var strINO = '';
          this.productFilters.invoiceNumber.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Invoice No : ' + strINO.substr(0, strINO.length - 2));
          this.filter.invoiceNumber = strINO.substr(0, strINO.length - 2);
        }

        // Set lot No
        if (this.productFilters.lotNumber && this.productFilters.lotNumber.length > 0) {
          var strINO = '';
          this.productFilters.lotNumber.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Lot No : ' + strINO.substr(0, strINO.length - 2));
          this.filter.lotNumber = strINO.substr(0, strINO.length - 2);
        }

        // Set Product Name
        if (this.productFilters.productName && this.productFilters.productName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.productName);
          this.filter.productName = this.productFilters.productName;
        }

        // Set Package Size
        if (this.productFilters.packageSize && this.productFilters.packageSize.length > 0) {
          var strINO = '';
          this.productFilters.packageSize.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strINO.substr(0, strINO.length - 2));
          this.filter.packageSize = strINO.substr(0, strINO.length - 2);
        }

        // Set Seed Size
        if (this.productFilters.seedSize && this.productFilters.seedSize.length > 0) {
          var strINO = '';
          this.productFilters.seedSize.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strINO.substr(0, strINO.length - 2));
          this.filter.seedSize = strINO.substr(0, strINO.length - 2);
        }

        // Set Treatment
        if (this.productFilters.treatment && this.productFilters.treatment.length > 0) {
          var strINO = '';
          this.productFilters.treatment.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strINO.substr(0, strINO.length - 2));
          this.filter.treatment = strINO.substr(0, strINO.length - 2);
        }

        // Set Technology
        if (this.productFilters.technology && this.productFilters.technology != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.technology);
          this.filter.technology = this.productFilters.technology;
        }

        // Set marketing brand
        if (this.productFilters.marketingBrand && this.productFilters.marketingBrand.length > 0) {
          var strINO = '';
          this.productFilters.marketingBrand.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strINO.substr(0, strINO.length - 2));
          this.filter.marketingBrand = strINO.substr(0, strINO.length - 2);
        }
      }
    }
    this.enableDisableSearchButton();
    this.searchValue = '';
    this.partialSearchValue = '';

    if (this.filterValueList.length < 1) {
      this.ClearFilter.emit(this.filter);
    }
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }
  // Remove all chip filters
  removeAllFilter() {
    if (this.filterValueList.length > 0) {
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.enableDisableSearchButton();
      this.filter.clearAll = true;
      this.SearchFilter.emit(this.filter);
    }
  }
  // Clear a selected filter value
  clearFilter(filterValue) {
    const index = filterValue ? this.filterValueList.indexOf(filterValue) : -1;
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      this.removeFilter(filterValue);
      this.enableDisableSearchButton();

      if (this.filterValueList.length < 1) {
        this.ClearFilter.emit(this.filter);
      }
    }
  }

  // Search button event
  onFilter() {
    this.retainFilter(null, ' ');
    this.SearchFilter.emit(this.filter);
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand(Product)
    if (productFilter.productName !== null && productFilter.productName !== '') {
      isValid = true;
    }
    // To Validate Brand(Product)
    if (productFilter.marketingBrand !== null && productFilter.marketingBrand !== '') {
      isValid = true;
    }

    // // To Validate PackageSize
    if (productFilter.packageSize != null && productFilter.packageSize !== '') {
      isValid = true;
    }

    // // To Validate SeedSize
    if (productFilter.seedSize != null && productFilter.seedSize !== '') {
      isValid = true;
    }

    // // To Validate PackageSize
    if (productFilter.technology != null && productFilter.technology !== '') {
      isValid = true;
    }

    // // To Validate PackageSize
    if (productFilter.treatment != null && productFilter.treatment !== '') {
      isValid = true;
    }

    // To Validate lotNumber
    if (productFilter.lotNumber != null && productFilter.lotNumber.length > 0) {
      isValid = true;
    }

    // To Validate itemNo
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate invoice number
    if (productFilter.invoiceNumber != null && productFilter.invoiceNumber.length > 0) {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.invoiceNumber == null || productFilter.invoiceNumber.length <= 0)
      && (productFilter.packageSize == null || productFilter.packageSize.length <= 0)
      && (productFilter.seedSize == null || productFilter.seedSize.length <= 0)
      && (productFilter.technology == null || productFilter.technology.length <= 0)
      && (productFilter.treatment == null || productFilter.treatment.length <= 0)
      && (productFilter.marketingBrand == null || productFilter.marketingBrand.length <= 0)
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && (productFilter.lotNumber == null || productFilter.lotNumber.length <= 0)) {
      isValid = false;
    }
    return isValid;
  }

  // Enable Disable Search
  enableDisableSearchButton() {
    if (this.validateFilter(this.productFilters)) {
      this.disableFilterBtn = false;
    }
    else {
      this.disableFilterBtn = true;
    }
  }

  // Remove a selected chip search filter
  removeFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.itemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Invoice No':
        this.productFilters.invoiceNumber = null;
        this.filter.invoiceNumber = null;
        break;
      case 'Lot No':
        this.productFilters.lotNumber = null;
        this.filter.lotNumber = null;
        break;
      case 'Product Name':
        this.productFilters.productName = null;
        this.filter.productName = null;
        break;
      case 'Marketing Brand':
        this.productFilters.marketingBrand = null;
        this.filter.marketingBrand = null;
        break;
      case 'Technology':
        this.productFilters.technology = null;
        this.filter.technology = null;
        break;
      case 'Treatment':
        this.productFilters.treatment = null;
        this.filter.treatment = null;
        break;
      case 'Package Size':
        this.productFilters.packageSize = null;
        this.filter.packageSize = null;
        break;
      default:
        break;
    }
  }

  // Re initialise the Filters
  resetFilterInputValue() {
    this.productFilters = {
      'itemNo': [],
      'invoiceNumber': [],
      'lotNumber': [],
      'productName': null,
      'marketingBrand': [],
      'packageSize': [],
      'seedSize': [],
      'treatment': [],
      'technology': null
    };

    this.filter = {
      'itemNo': null,
      'clearAll': false,
      'lotNumber': null,
      'invoiceNumber': null,
      'productName': null,
      'marketingBrand': null,
      'packageSize': null,
      'seedSize': null,
      'treatment': null,
      'technology': null
    };
  }
  // Page destroy event
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
